import { CUSTOMERS, CUSTOMERS_SEARCH } from "../../types/CustomerType";
import axios from "axios";

const getCustomer = (data) => {
	return {
		type: CUSTOMERS,
		payload: data,
	};
};

const getCustomerSearch = (data) => {
	return {
		type: CUSTOMERS_SEARCH,
		payload: data,
	};
};

export const loadAllCustomer = ({ page, limit, status }) => {
	//dispatching with an call back function and returning that
	return async (dispatch) => {
		try {
			const { data } = await axios.get(
				`customer?status=${status}&page=${page}&count=${limit}`
			);
			//dispatching data
			dispatch(getCustomer(data));
		} catch (error) {
			console.log(error.message);
		}
	};
};

export const loadAllCustomersForSearch = ({ status }) => {
	//dispatching with an call back function and returning that
	return async (dispatch) => {
		try {
			console.log("Loading all customers for search with status:", status);
			const url = `customer?query=all&status=${status}`;
			console.log("API URL:", url);
			const { data } = await axios.get(url);
			console.log("Search customers loaded:", data.length);
			console.log("First customer:", data[0]);
			//dispatching data
			dispatch(getCustomerSearch(data));
		} catch (error) {
			console.log("Error loading search customers:", error.message);
			console.log("Error response:", error.response?.data);
		}
	};
};